import { createContext, useCallback, useContext } from "react";
import { Bounce, ToastContainer, toast } from "react-toastify";

export const NotificationContext = createContext();

const NotificationProvider = ({ children }) => {
  const openNotification = useCallback((message) => toast(message), []);

  return (
    <NotificationContext.Provider value={{ openNotification }}>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Bounce}
      />
      {children}
    </NotificationContext.Provider>
  );
};

export default NotificationProvider;

export const useNotification = () => useContext(NotificationContext);
